var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareLinkedIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      pointerEvents: "none",
      display: "block",
      width: "100%",
      height: "100%"
    },
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0077B5",
    fillRule: "nonzero",
    d: "M28.486 59.97c-6.636-.57-11.563-2.328-16.322-5.825C4.444 48.472 0 39.647 0 29.987 0 15.112 10.507 2.798 25.274.367c6.029-.992 12.704.05 18.288 2.854 13.577 6.818 19.782 22.54 14.643 37.103-3.528 9.998-12.79 17.618-23.391 19.245-2.086.32-5.065.509-6.328.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17.88 22.082c2.142 0 3.878-1.584 3.878-3.54S20.022 15 17.88 15C15.736 15 14 16.586 14 18.543c0 1.955 1.736 3.539 3.88 3.539M14.89 44.847h6.958v-20.07H14.89zm16.725-11.162c0-2.302 1.089-4.552 3.692-4.552 2.604 0 3.244 2.25 3.244 4.497v10.96h6.928V33.183c0-7.927-4.686-9.293-7.568-9.293-2.88 0-4.468.974-6.296 3.334v-2.702h-6.947v20.07h6.947V33.685z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareLinkedIn);
export default __webpack_public_path__ + "static/media/ShareLinkedIn.05f06b2dcd3ebb7bd6f58c41a58ba760.svg";
export { ForwardRef as ReactComponent };